import { contractCancellation } from './contractCancellation';
import { profile } from './profile';

const esCR = {
  ...contractCancellation,
  ...profile,
};

export default esCR;
